var map = {
	"./static/assets/logos/blogr.svg": "29ac",
	"./static/assets/logos/coffeeroasters.svg": "00c4",
	"./static/assets/logos/creative.svg": "e93b",
	"./static/assets/logos/crowdfund.svg": "0490",
	"./static/assets/logos/maker.svg": "5802",
	"./static/assets/logos/mastercraft.svg": "ba21",
	"./static/assets/logos/officelite.svg": "4430",
	"./static/assets/logos/pod.svg": "3003",
	"./static/assets/logos/pomodoro.svg": "0e5f",
	"./static/assets/logos/scoot.svg": "604e",
	"./static/assets/logos/typemaster.svg": "91d5",
	"./static/assets/logos/vector.svg": "1474"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8e1";